import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cde2fa1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-services-container" }
const _hoisted_2 = { class: "home-services-service-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-service-image home-service-image-insurances" }, null, -1))
const _hoisted_4 = { class: "home-services-title" }
const _hoisted_5 = { class: "home-services-description" }
const _hoisted_6 = { class: "home-services-description" }
const _hoisted_7 = { class: "home-services-service-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-service-image home-service-image-finances" }, null, -1))
const _hoisted_9 = { class: "home-services-title" }
const _hoisted_10 = { class: "home-services-description" }
const _hoisted_11 = { class: "home-services-description" }
const _hoisted_12 = { class: "home-services-description" }
const _hoisted_13 = { class: "home-services-description" }
const _hoisted_14 = { class: "home-services-service-container" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "home-service-image home-service-image-properties" }, null, -1))
const _hoisted_16 = { class: "home-services-title" }
const _hoisted_17 = { class: "home-services-description" }
const _hoisted_18 = { class: "home-services-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t("home.services.insurances")), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("home.services.insurances-description-1")), 1),
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("home.services.insurances-description-2")), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.$t("home.services.finances")), 1),
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("home.services.finances-description-1")), 1),
      _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("home.services.finances-description-2")), 1),
      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("home.services.finances-description-3")), 1),
      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("home.services.finances-description-4")), 1)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.$t("home.services.properties")), 1),
      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("home.services.properties-description-1")), 1),
      _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("home.services.properties-description-2")), 1)
    ])
  ]))
}